import React, { useState, useEffect } from 'react';

export default function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect if already installed as PWA
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setIsInstalled(true);
      return;
    }

    // Detect iOS
    const ua = window.navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    setIsIOS(iOS);

    // Listen for beforeinstallprompt (Chrome/Android)
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (isInstalled) return null;

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      // Chrome/Android: use native prompt
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setIsInstalled(true);
      }
      setDeferredPrompt(null);
    } else {
      // iOS or no prompt available: show instructions
      setShowModal(true);
    }
  };

  return (
    <>
      <button
        onClick={handleInstallClick}
        style={{
          width: '100%',
          padding: '14px 20px',
          borderRadius: '12px',
          border: '1px solid var(--accent)',
          background: 'transparent',
          color: 'var(--accent)',
          fontSize: '15px',
          fontWeight: '600',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          marginTop: '12px',
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        Descargar App
      </button>

      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
            display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
            zIndex: 9999, padding: '0 0 0 0',
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: 'var(--card)', width: '100%', maxWidth: '480px',
              borderRadius: '20px 20px 0 0', padding: '24px 20px 32px',
              animation: 'slideUp 0.3s ease',
            }}
          >
            <div style={{ width: '40px', height: '4px', background: 'var(--border)', borderRadius: '2px', margin: '0 auto 20px' }} />
            
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
              <img src="/tuki-logo.jpg" alt="TUKI" style={{ width: '64px', height: '64px', borderRadius: '14px', marginBottom: '12px' }} />
              <h3 style={{ fontSize: '18px', fontWeight: '700', color: 'var(--text)' }}>Instalar TUKI</h3>
              <p style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '4px' }}>Accede rápido desde tu pantalla de inicio</p>
            </div>

            {isIOS ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: 'var(--card2)', borderRadius: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: '700', fontSize: '16px', flexShrink: 0 }}>1</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text)' }}>Toca el botón Compartir</div>
                    <div style={{ fontSize: '12px', color: 'var(--text2)' }}>El ícono <span style={{ fontSize: '16px' }}>⬆</span> en la barra de Safari</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: 'var(--card2)', borderRadius: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: '700', fontSize: '16px', flexShrink: 0 }}>2</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text)' }}>Selecciona "Agregar a inicio"</div>
                    <div style={{ fontSize: '12px', color: 'var(--text2)' }}>Busca la opción <span style={{ fontSize: '14px' }}>➕</span> Agregar a pantalla de inicio</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: 'var(--card2)', borderRadius: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: '700', fontSize: '16px', flexShrink: 0 }}>3</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text)' }}>Toca "Agregar"</div>
                    <div style={{ fontSize: '12px', color: 'var(--text2)' }}>TUKI aparecerá en tu pantalla de inicio</div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: 'var(--card2)', borderRadius: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: '700', fontSize: '16px', flexShrink: 0 }}>1</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text)' }}>Abre el menú del navegador</div>
                    <div style={{ fontSize: '12px', color: 'var(--text2)' }}>Toca los 3 puntos <span style={{ fontSize: '14px' }}>⋮</span> arriba a la derecha</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: 'var(--card2)', borderRadius: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: '700', fontSize: '16px', flexShrink: 0 }}>2</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text)' }}>Selecciona "Instalar app"</div>
                    <div style={{ fontSize: '12px', color: 'var(--text2)' }}>O "Agregar a pantalla de inicio"</div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px', background: 'var(--card2)', borderRadius: '12px' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: '700', fontSize: '16px', flexShrink: 0 }}>3</div>
                  <div>
                    <div style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text)' }}>Confirma la instalación</div>
                    <div style={{ fontSize: '12px', color: 'var(--text2)' }}>TUKI aparecerá como app en tu dispositivo</div>
                  </div>
                </div>
              </div>
            )}

            <button
              onClick={() => setShowModal(false)}
              style={{
                width: '100%', marginTop: '20px', padding: '14px',
                borderRadius: '12px', background: 'var(--accent)',
                color: '#000', fontWeight: '700', fontSize: '15px',
                border: 'none', cursor: 'pointer'
              }}
            >
              Entendido
            </button>
          </div>
        </div>
      )}

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); }
          to { transform: translateY(0); }
        }
      `}</style>
    </>
  );
}
